export const DIALER_SETTINGS_TAB_NAV = [
  { name: "General", id: "generalTab", path: "general" },
  { name: "Manage Numbers", id: "manageNumbersTab", path: "manageNumbers", adminOnly: true },
  { name: "Call Disposition", id: "callDispositionTab", path: "callDisposition" },
  { name: "Voicemail", id: "voicemailTab", path: "voicemail", featureTitle: "VOICEMAIL_DROP" },
  { name: "Power Dialer", id: "powerDialerTab", path: "powerDialer", featureTitle: "POWER_DIALER" }
];

export const COLOR_CODES = [
  "#82E0AAFC",
  "#D2B4DE",
  "#D98880",
  "#7FB3D5",
  "#EC7063",
  "#808B96",
  "#2C3E50",
  "#E59866",
  "#CD6155",
  "#A569BD",
  "#5499C7",
  "#45B39D",
  "#F8C471",
  "#99A3A4",
  "#273746"
];
